import React, { useState, useMemo, useCallback } from 'react';
import FilterTemplate from '../components/filtertemplate/FilterTemplate';
import { fetchTFNPayments, downloadTFNcalculations_, createTFNBank,downloadTFNcalculations_super } from '../utils/api';
import { cssUrl } from '../utils/cssVersion';
import HelpButton from '../components/shared/HelpButton';
import { SuperIcon } from '../components/shared/Icons';
const filterTemplateStyles = cssUrl('filterTemplate.css');


const F = {
  id: 0, email: 1, payEnd: 2, gross: 3, net: 4, payg: 5, super: 6,
  annualSalary: 7, annualLeave: 8, sick: 9, longService: 10,
  bankName: 11, bsb: 12, account: 13, month: 14, year: 15,
  fullName: 16, status: 17,
};

const PAYMENTS_VALUE = 'Not_Paid';
const STATUS_CHIPS = [
  { label: 'Payments', value: 'Not_Paid' },
  { label: 'Paid', value: 'Paid' },
];

const HELP = { chip: 'employee_payments', urlFilter: '/static/pdffilters/EmployeePayments.pdf' };


const parseCurrency = (s) => {
  if (typeof s === 'number') return s;
  const n = parseFloat(String(s ?? '').replace(/[$,]/g, ''));
  return Number.isFinite(n) ? n : 0;
};
const fmt = (n) =>
  `$${Number(n).toLocaleString('en-AU', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
const parseDMY = (s) => {
  const [d, m, y] = String(s ?? '').split('/').map(Number);
  return d && m && y ? new Date(y, m - 1, d) : null;
};
const eyebrowFor = (date) => {
  const d = parseDMY(date);
  return d && d.getDate() <= 20 ? 'Mid month (15th)' : 'End of month';
};
const downloadBlob = (blob, filename) => {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
};

const EMP_COLS = '1.5fr repeat(4, minmax(0, 1fr)) 0.9fr';


const S = {
  eyebrow: { fontSize: '0.62rem', letterSpacing: '0.14em', textTransform: 'uppercase', color: '#22d3ee', fontWeight: 700 },
  totalsWrap: { display: 'flex', gap: 8, padding: '6px 0 4px', flexWrap: 'wrap' },
  totalPill: { flex: '1 1 0', minWidth: 120, textAlign: 'center', borderRadius: 12, padding: '8px 10px', background: 'rgba(34,211,238,0.08)', border: '1px solid rgba(34,211,238,0.25)' },
  totalLabel: { fontSize: '0.68rem', color: 'rgba(255,255,255,0.45)', textTransform: 'uppercase', letterSpacing: '0.05em' },
  totalValue: { fontSize: '0.95rem', fontWeight: 700, color: '#22d3ee', whiteSpace: 'nowrap' },
  link: { background: 'none', border: 'none', color: '#22d3ee', cursor: 'pointer', fontWeight: 600, padding: 0, marginLeft: 4 },
  blockColHead: { fontSize: '0.62rem', letterSpacing: '0.05em', textTransform: 'uppercase', color: 'rgba(255,255,255,0.45)', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' },
  blockRowLabel: { fontSize: '0.85rem', fontWeight: 700, color: '#22d3ee', whiteSpace: 'nowrap' },
  blockValue: { textAlign: 'right', fontSize: '0.86rem' },
  statusBadge: { display: 'inline-block', padding: '3px 10px', borderRadius: 999, fontSize: '0.72rem', fontWeight: 700 },
  /* detail modal */
  panelAccent: { position: 'absolute', top: 0, left: 0, right: 0, height: 3, background: 'linear-gradient(90deg, #22d3ee, #3b82f6, #8b5cf6)' },
  modalBackdrop: { position: 'fixed', inset: 0, top: 'var(--fr-modal-top, 0px)', background: 'rgba(2,6,23,0.7)', zIndex: 1100, display: 'flex', alignItems: 'flex-start', justifyContent: 'center', padding: '40px 16px', overflowY: 'auto' },
  modal: { position: 'relative', overflow: 'hidden', width: '100%', maxWidth: 520, background: 'linear-gradient(135deg, #1e293b 0%, #0f172a 100%)', border: '1px solid rgba(34,211,238,0.25)', borderRadius: 16, padding: '18px 18px 10px' },
  modalHead: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 14 },
  modalTitle: { margin: 0, fontSize: '1rem', fontWeight: 700, color: '#f1f5f9' },
  closeX: { background: 'none', border: 'none', color: 'rgba(255,255,255,0.6)', fontSize: '1.4rem', lineHeight: 1, cursor: 'pointer' },
  field: { background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.08)', borderRadius: 10, padding: '8px 12px', marginBottom: 10 },
  fieldLabel: { display: 'block', fontSize: '0.6rem', letterSpacing: '0.06em', textTransform: 'uppercase', color: 'rgba(255,255,255,0.4)', marginBottom: 3 },
  fieldValue: { fontSize: '0.9rem', fontWeight: 600, color: '#e2e8f0', wordBreak: 'break-word' },
  groupHead: { fontSize: '0.7rem', letterSpacing: '0.1em', textTransform: 'uppercase', color: '#22d3ee', fontWeight: 700, margin: '12px 2px 8px' },
  row2: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 },
  row3: { display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 10 },
  closeBtn: { width: '100%', padding: '11px', borderRadius: 10, border: 'none', background: 'rgba(255,255,255,0.06)', color: '#e2e8f0', fontWeight: 600, cursor: 'pointer', margin: '6px 0 8px' },
};


const SheetIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M14 3v4a1 1 0 0 0 1 1h4" />
    <path d="M17 21H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7l5 5v11a2 2 0 0 1-2 2z" />
    <path d="M8 9h2M8 13h8M8 17h8" />
  </svg>
);
const BankIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 21h18" />
    <path d="M4 10h16" />
    <path d="M5 6l7-3 7 3" />
    <path d="M6 10v8M10 10v8M14 10v8M18 10v8" />
  </svg>
);


const StatusBadge = ({ status }) => {
  const paid = String(status).toLowerCase() === 'paid';
  const st = paid
    ? { background: 'rgba(34,197,94,0.15)', color: '#4ade80', border: '1px solid rgba(34,197,94,0.4)' }
    : { background: 'rgba(251,191,36,0.15)', color: '#fbbf24', border: '1px solid rgba(251,191,36,0.4)' };
  return <span style={{ ...S.statusBadge, ...st }}>{status || '—'}</span>;
};

const SectionHead = ({ eyebrow, badge }) => (
  <div style={{ display: 'flex', alignItems: 'baseline', justifyContent: 'space-between', gap: 10, margin: '0 0 12px' }}>
    <span style={S.eyebrow}>{eyebrow}</span>
    {badge != null && badge !== '' && (
      <span className="fr-card-date-end" style={{ fontSize: '0.85rem', fontWeight: 600, whiteSpace: 'nowrap' }}>{badge}</span>
    )}
  </div>
);


const EmployeeBlock = ({ eyebrow, badge, rows, onRowClick }) => (
  <div style={{ marginBottom: 26 }}>
    <SectionHead eyebrow={eyebrow} badge={badge} />
    <div className="fr-card" style={{ cursor: 'default' }}>
      <div style={{ overflowX: 'auto' }}>
        <div style={{ minWidth: 620 }}>
          <div style={{ display: 'grid', gridTemplateColumns: EMP_COLS, alignItems: 'end', padding: '0 8px 10px', marginBottom: 2, borderBottom: '1px solid rgba(255,255,255,0.12)' }}>
            <span style={S.blockColHead}>Employee</span>
            {['Gross', 'Net', 'PAYG', 'Super'].map((h) => (
              <span key={h} style={{ ...S.blockColHead, textAlign: 'right' }}>{h}</span>
            ))}
            <span style={{ ...S.blockColHead, textAlign: 'right' }}>Status</span>
          </div>
          {rows.map((r, i) => (
            <div
              key={r.id || i}
              className="ep-row"
              onClick={() => onRowClick(r.record)}
              style={{
                display: 'grid', gridTemplateColumns: EMP_COLS, alignItems: 'center',
                padding: '10px 8px', cursor: 'pointer', borderRadius: 8,
                borderTop: i ? '1px solid rgba(255,255,255,0.06)' : 'none',
              }}
            >
              <span style={S.blockRowLabel}>{r.name || '—'}</span>
              <span className="fr-card-value" style={S.blockValue}>{r.gross}</span>
              <span className="fr-card-value" style={S.blockValue}>{r.net}</span>
              <span className="fr-card-value" style={S.blockValue}>{r.payg}</span>
              <span className="fr-card-value" style={S.blockValue}>{r.super}</span>
              <span style={{ textAlign: 'right' }}><StatusBadge status={r.status} /></span>
            </div>
          ))}
        </div>
      </div>
    </div>
  </div>
);

const TotalsPills = ({ items }) => {
  const t = useMemo(() => {
    const acc = { gross: 0, net: 0, payg: 0, super: 0 };
    (items || []).forEach((r) => {
      acc.gross += parseCurrency(r[F.gross]);
      acc.net += parseCurrency(r[F.net]);
      acc.payg += parseCurrency(r[F.payg]);
      acc.super += parseCurrency(r[F.super]);
    });
    return acc;
  }, [items]);
  return (
    <div style={S.totalsWrap}>
      <div style={S.totalPill}><div style={S.totalLabel}>Gross</div><div style={S.totalValue}>{fmt(t.gross)}</div></div>
      <div style={S.totalPill}><div style={S.totalLabel}>Net</div><div style={S.totalValue}>{fmt(t.net)}</div></div>
      <div style={S.totalPill}><div style={S.totalLabel}>PAYG</div><div style={S.totalValue}>{fmt(t.payg)}</div></div>
      <div style={S.totalPill}><div style={S.totalLabel}>Super</div><div style={S.totalValue}>{fmt(t.super)}</div></div>
    </div>
  );
};


const Field = ({ label, value }) => (
  <div style={S.field}>
    <span style={S.fieldLabel}>{label}</span>
    <div style={S.fieldValue}>{value === '' || value == null ? '—' : value}</div>
  </div>
);

const ReadOnlyModal = ({ item, onClose }) => {
  if (!item) return null;
  const money = (i) => fmt(parseCurrency(item[i]));
  return (
    <div style={S.modalBackdrop} onClick={onClose}>
      <div style={S.modal} onClick={(e) => e.stopPropagation()}>
        <div style={S.panelAccent} />
        <div style={S.modalHead}>
          <h4 style={S.modalTitle}>Employee Payment</h4>
          <button type="button" style={S.closeX} onClick={onClose} aria-label="Close">×</button>
        </div>

        <Field label="Employee" value={item[F.fullName]} />
        <Field label="Email" value={item[F.email]} />
        <div style={S.row2}>
          <Field label="Annual Salary" value={money(F.annualSalary)} />
          <Field label="Gross Salary" value={money(F.gross)} />
        </div>
        <div style={S.row3}>
          <Field label="Net Pay" value={money(F.net)} />
          <Field label="PAYG" value={money(F.payg)} />
          <Field label="Super" value={money(F.super)} />
        </div>
        <Field label="Payment Status" value={item[F.status]} />

        <div style={S.groupHead}>Leave Balances</div>
        <div style={S.row3}>
          <Field label="Annual" value={item[F.annualLeave]} />
          <Field label="Sick" value={item[F.sick]} />
          <Field label="Long Service" value={item[F.longService]} />
        </div>

        <div style={S.groupHead}>Bank Details</div>
        <Field label="Bank A/C Name" value={item[F.bankName]} />
        <div style={S.row2}>
          <Field label="BSB" value={item[F.bsb]} />
          <Field label="A/C Number" value={item[F.account]} />
        </div>

        <button type="button" style={S.closeBtn} onClick={onClose}>Close</button>
      </div>
    </div>
  );
};


const BankAction = ({ monthYear, chipQuery, setToast, refetch }) => {
  const [busy, setBusy] = useState(false);
  const onClick = async () => {
    if (chipQuery !== PAYMENTS_VALUE) {
      setToast({ message: 'Select the Payments chip before downloading the bank file.', type: 'error' });
      return;
    }
    try {
      setBusy(true);
      const { blob, approvedCount } = await createTFNBank({ monthYear });
      downloadBlob(blob, 'payroll_employee.aba');
      setToast({ message: `${approvedCount} record${approvedCount === 1 ? '' : 's'} approved to Paid.`, type: 'success' });
      if (refetch) await refetch();
    } catch (e) {
      setToast({ message: e.message || 'Failed to create bank file', type: 'error' });
    } finally {
      setBusy(false);
    }
  };
  return (
    <button type="button" className="fr-download-btn" onClick={onClick} disabled={busy} title="Download bank file (.aba) — Payments chip required" style={busy ? { opacity: 0.5 } : undefined}>
      <BankIcon />
    </button>
  );
};

const ExcelAction = ({ monthYear, setToast }) => {
  const [busy, setBusy] = useState(false);
  const onClick = async () => {
    try {
      setBusy(true);
      const blob = await downloadTFNcalculations_(monthYear);
      downloadBlob(blob, `tfnpaymentscalculations_${monthYear || 'month'}.xlsx`);
    } catch (e) {
      setToast({ message: e.message || 'Download failed', type: 'error' });
    } finally {
      setBusy(false);
    }
  };
  return (
    <button type="button" className="fr-download-btn" onClick={onClick} disabled={busy} title="Download employee payment calculations (Excel)" style={busy ? { opacity: 0.5 } : undefined}>
      <SheetIcon />
    </button>
  );
};

const SuperAction = ({ monthYear, setToast }) => {
  const [busy, setBusy] = useState(false);
  const onClick = async () => {
    try {
      setBusy(true);
      const blob = await downloadTFNcalculations_super(monthYear);
      downloadBlob(blob, `tfnpaymentsuper_${monthYear || 'month'}.xlsx`);
    } catch (e) {
      setToast({ message: e.message || 'Download failed', type: 'error' });
    } finally {
      setBusy(false);
    }
  };
  return (
    <button type="button" className="fr-download-btn" onClick={onClick} disabled={busy} title="Download employee super data (Excel)" style={busy ? { opacity: 0.5 } : undefined}>
      <SuperIcon />
    </button>
  );
};

const EmployeePayments = ({ showHeader = false }) => {
  
  const [visible, setVisible] = useState([]);

  const renderChips = useCallback((chipQuery, setChipQuery) => (
    <div>
      <div className="fr-filter-chips">
        {STATUS_CHIPS.map((c) => {
          const active = chipQuery === c.value;
          return (
            <button
              key={c.value}
              type="button"
              className={`fr-chip${active ? ' fr-chip-active' : ''}`}
              style={active ? { background: 'rgba(34,211,238,0.15)', color: '#22d3ee', borderColor: 'rgba(34,211,238,0.5)' } : undefined}
              onClick={() => setChipQuery(active ? '' : c.value)}
            >
              {c.label}
            </button>
          );
        })}
        {chipQuery && (
          <button type="button" style={S.link} onClick={() => setChipQuery('')}>Clear filter</button>
        )}
      </div>
      <TotalsPills items={visible} />
    </div>
  ), [visible]);

  
  const renderCard = useCallback((item, onCardClick) => {
    const date = item[F.payEnd] || 'Unknown';
    const found = visible.filter((r) => (r[F.payEnd] || 'Unknown') === date);
    const group = found.length ? found : [item];
    const isFirst = String(group[0]?.[F.id]) === String(item[F.id]);
    if (!isFirst) return null;

    const rows = group.map((rec) => ({
      id: rec[F.id],
      record: rec,
      name: rec[F.fullName],
      gross: fmt(parseCurrency(rec[F.gross])),
      net: fmt(parseCurrency(rec[F.net])),
      payg: fmt(parseCurrency(rec[F.payg])),
      super: fmt(parseCurrency(rec[F.super])),
      status: rec[F.status],
    }));

    return <EmployeeBlock eyebrow={eyebrowFor(date)} badge={date} rows={rows} onRowClick={onCardClick} />;
  }, [visible]);

  const renderModal = useCallback(
    (item, onClose) => <ReadOnlyModal item={item} onClose={onClose} />,
    []
  );

  const renderExtraActions = useCallback(
    ({ selectedMonthYear, chipQuery, setToast, getData }) => (
      <>
        <BankAction
          monthYear={selectedMonthYear}
          chipQuery={chipQuery}
          setToast={setToast}
          refetch={() => getData(selectedMonthYear, false)}
        />
        <ExcelAction monthYear={selectedMonthYear} setToast={setToast} />
        <SuperAction monthYear={selectedMonthYear} setToast={setToast} />
      </>
    ),
    []
  );

  return (
    <>
      <style>{`
        .ep-row { transition: background .12s ease; }
        .ep-row:hover { background: rgba(34,211,238,0.07); }
      `}</style>

      <FilterTemplate
        title="Employee Payments"
        showHeader={showHeader}
        stylesheetHref={filterTemplateStyles}
        fetchData={fetchTFNPayments}
        dataKey="tfnpayments"
        searchFields={[F.status]}            // chips match Pay Status (exact)
        typingSearchFields={[F.fullName]}    // typed search matches employee name
        searchPlaceholder="Search employee name…"
        helpButton={<HelpButton helpData={[HELP]} />}
        renderChips={renderChips}
        renderCard={renderCard}
        renderModal={renderModal}
        renderExtraActions={renderExtraActions}
        onFilteredChange={setVisible}
        emptyIcon="💸"
        emptyTitle="No Employee Payments"
        loadingMessage="Loading employee payments…"
      />
    </>
  );
};

export default EmployeePayments;